import {lazy} from "react";

export const CameraSnapShotsByTimeWithFiltersLazy = lazy(()=>import('./CameraSnapShotsByTimeWithFilters'))